import Vue from 'vue'
import Router from 'vue-router'

import { _getCookie } from '@/plugins/mixin.js'

// register navigation
Vue.use(Router)

const options = {
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            component: () => import('../pages/OptInPage'),
            meta: {
                auth: true
            }
        },
        {
            path: '/settings',
            component: () => import('../pages/CookieSetterPage'),
        },
        {
            path: '/na',
            component: () => import('../pages/NotAllowedPage')
        },

        // ----- DEFAULT ROUTE MUST BE LAST! -----
        {
            path: '*',
            name: 'notfound',
            component: () => import('../pages/OptInPage'),
            // always redirect to landing page
            beforeEnter: (to, from, next) => {
                next('/')
            }
        }
    ],
}

const router = new Router(options)

router.beforeEach((to, from, next) => {
    if (to.meta.auth) {
        // check if the correct cookie is set
        const cookie = _getCookie()

        if (!cookie
            || cookie.client !== process.env.VUE_APP_CLIENT
            || cookie.profile !== process.env.VUE_APP_PROFILE_NAME) {
                next('/na')
        } else if (!Vue.prototype.$keycloak.authenticated) {
            Vue.prototype.$keycloak.login()
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router;
